import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { APP_PRIMENG_MODULE } from '../packages/primeng.package';
import { APP_UTILITY_MODULE } from '../packages/utils.package';
import { SmallPlayerModule } from '../../components/small-player/small-player.module';

const imp_arrray = [ 
  CommonModule,
  APP_PRIMENG_MODULE,
  APP_UTILITY_MODULE,
  SmallPlayerModule
]
@NgModule({
  declarations: [],
  imports: imp_arrray,
  exports:imp_arrray
})
export class AppModule { }
